import { CleanSearchTerm } from "event-definitions"
import { useDebouncedValue } from "lib/@hooks/useDebouncedValue"
import { noop } from "library/noop/index.mjs"

export function useCleanDebouncedValue(initial, time = 500, cb = noop) {
    const [current, setValue, throttled] = useDebouncedValue(initial, time, handleCleanSearch)
    return [current, setValue, throttled]

    function handleCleanSearch(value) {
        const cleanedSearch = clearSearchTerm(value)
        cb(cleanedSearch)
    }
}

export function clearSearchTerm(value) {
    const [{ searchTerm }] = CleanSearchTerm.raise({ searchTerm: value })
    return searchTerm
}
